<template>
  <Modal :open="open" size="medium" @close="$emit('close')">
    <template v-if="isImage">
      <div class="text-center mb-4">
        <h3 class="text-xl font-semibold text-gray-900">{{ title }}</h3>
      </div>
      <div
        class="w-full overflow-auto rounded-lg border border-gray-200 bg-gray-50 flex items-start justify-center p-2"
      >
        <img :src="url" :alt="title" class="max-w-full h-auto object-contain" loading="lazy" />
      </div>
    </template>
    <FileFrame v-else-if="resolvedUrl" :title="title" :file-url="resolvedUrl" />
  </Modal>
</template>

<script>
import { Modal, FileFrame } from "@estaly/ui";

export default {
  components: { Modal, FileFrame },

  props: {
    open: { type: Boolean, required: true },
    url: { type: String, default: "" },
    title: { type: String, default: "" },
  },

  emits: ["close"],

  computed: {
    isImage() {
      return /\.(png|jpe?g|gif|webp)(\?.*)?$/i.test(this.url);
    },
    resolvedUrl() {
      if (!this.url) return null;
      return this.isImage
        ? this.url
        : `https://docs.google.com/viewer?url=${encodeURIComponent(this.url)}&embedded=true`;
    },
  },
};
</script>
